export type PremiumNewsItem = {
  date: string;
  label: string;
  title: string;
  summary: string;
  tag: string;
};

export const premiumNewsItems: PremiumNewsItem[] = [
  {
    date: "2026-05-08",
    label: "8 mei 2026",
    title: "Sneller starten vanaf de homepage",
    summary:
      "De startsectie is vernieuwd met vaste keuzes voor klas, hoofdstuk en modus.",
    tag: "Homepage"
  },
  {
    date: "2026-04-24",
    label: "24 april 2026",
    title: "Verbeterde hoofdstuknavigatie",
    summary:
      "Hoofdstukken zijn overzichtelijker gegroepeerd, zodat je minder hoeft te zoeken.",
    tag: "Navigatie"
  },
  {
    date: "2026-04-10",
    label: "10 april 2026",
    title: "Voorbeeldvraag op de startpagina",
    summary:
      "Vanaf de startpagina kun je een korte voorbeeldvraag openen die de belangrijkste onderdelen laat zien.",
    tag: "Voorbeeldvraag"
  },
  {
    date: "2026-03-27",
    label: "27 maart 2026",
    title: "Duidelijkere voortgang per onderwerp",
    summary:
      "Je ziet sneller welke onderdelen aandacht nodig hebben en waar je al sterk in bent.",
    tag: "Voortgang"
  },
  {
    date: "2026-03-12",
    label: "12 maart 2026",
    title: "Nieuwe uitlegkaarten bij lastige stappen",
    summary:
      "Bij geselecteerde onderwerpen zijn korte uitlegkaarten toegevoegd voor tussenstappen.",
    tag: "Uitleg"
  }
];

export type PremiumFeatureKey =
  | "hint"
  | "stappenplan"
  | "bijlesbot"
  | "theorie"
  | "begripvraag"
  | "huiswerkmodus"
  | "schrift-feedback"
  | "oefentoets";

export type PremiumFeature = {
  key: PremiumFeatureKey;
  title: string;
  summary: string;
  where: string;
  locationDetail: string;
  details: string;
  discoveryHint: string;
};

export const premiumFeatures: PremiumFeature[] = [
  {
    key: "hint",
    title: "Hint",
    summary: "Krijg een duwtje in de juiste richting.",
    where: "Bij een opgave",
    locationDetail:
      "Open Losse opgave. Eerst krijg je een hint. Als je daarna meer hulp wilt, open je het stappenplan.",
    details:
      "Als je vastloopt bij een opgave begint WisWiz met een duwtje in de juiste richting.",
    discoveryHint: "Wordt gemarkeerd zodra je een hint bij een echte opgave ziet."
  },
  {
    key: "stappenplan",
    title: "Stappenplan",
    summary: "Zie niet alleen hoe, maar ook waarom.",
    where: "Na de hint",
    locationDetail:
      "Na de hint kun je het stappenplan openen. Met Volgende stap ga je rustig door de aanpak, berekeningen en het antwoord.",
    details:
      "Het stappenplan begint met een aanpakstap. Vervolgens wordt van iedere stap niet alleen uitgelegd hoe, maar ook waarom je hem zet.",
    discoveryHint:
      "Wordt gemarkeerd zodra je een stappenplan bij een echte opgave opent."
  },
  {
    key: "bijlesbot",
    title: "BijlesBot",
    summary: "Vraag door tot je het snapt.",
    where: "Onder het stappenplan",
    locationDetail:
      "Onder de uitleg staat een vak waarin je je vraag kunt typen. Stel daar een vraag over de stap die je ziet, of over de hele opgave.",
    details:
      "De BijlesBot kent deze opgave en helpt je net als een bijlesleraar tot je het snapt.",
    discoveryHint:
      "Wordt gemarkeerd zodra je je eerste vraag aan de BijlesBot instuurt."
  },
  {
    key: "theorie",
    title: "Theorie",
    summary: "Krijg theorie precies wanneer je die nodig hebt.",
    where: "Bij een stap",
    locationDetail:
      "Bij sommige stappen staat een theorieknop. Daarmee open je direct de uitleg die bij die stap hoort.",
    details:
      "Bij sommige stappen hoort theorie die je misschien vergeten bent, of die nooit helemaal klikte. WisWiz toont die precies op het moment dat je hem nodig hebt.",
    discoveryHint: "Wordt gemarkeerd zodra je op een theorieknop klikt."
  },
  {
    key: "begripvraag",
    title: "Begripvraag",
    summary: "Controleer of je snapt waarom een stap klopt.",
    where: "Na het eindantwoord",
    locationDetail:
      "Als het stappenplan klaar is, kun je een begripvraag openen. Daarmee oefen je kort of je de uitleg echt snapt.",
    details:
      "Een begripvraag gaat over de gedachte achter een stap. Zo merk je of je het idee begrijpt, niet alleen de berekening.",
    discoveryHint: "Wordt gemarkeerd zodra een begripvraag zichtbaar is."
  },
  {
    key: "huiswerkmodus",
    title: "Huiswerkmodus",
    summary: "Werk een reeks opgaven af zonder steeds terug te navigeren.",
    where: "Startpagina en bibliotheek",
    locationDetail:
      "Klik op Huiswerkset. Kies daarna de opgaven die je wilt maken en start de set.",
    details:
      "WisWiz bewaart welke opgaven in je set zitten. Daardoor kun je later weer verder waar je was.",
    discoveryHint: "Niet zichtbaar in de ontdek-lijst zolang huiswerkmodus buiten scope is."
  },
  {
    key: "schrift-feedback",
    title: "Feedback op je schrift",
    summary:
      "Maak een foto van je uitwerking en krijg feedback op je stappen.",
    where: "Bij een opgave",
    locationDetail:
      "Kies Zelf uitwerken bij een opgave. Daarna kun je een foto van je schrift toevoegen en laten nakijken.",
    details:
      "Door foto's van je schrift te maken kan WisWiz met je uitwerking meekijken. Zo kunnen we je bij jouw uitwerking verder helpen, een vraag beantwoorden of zelfs je uitwerking nakijken.",
    discoveryHint:
      "Wordt gemarkeerd zodra je een schriftfoto succesvol instuurt."
  },
  {
    key: "oefentoets",
    title: "Oefentoets",
    summary: "Check of je de stof beheerst.",
    where: "In het hoofdstukmenu",
    locationDetail:
      "Open in de bibliotheek de oefentoets bij je hoofdstuk. Daarna maak je de vragen een voor een.",
    details:
      "WisWiz oefentoetsen sluiten inhoudelijk aan op je hoofdstuk. Je oefent zelfstandiger en ziet daarna wat nog beter kan.",
    discoveryHint:
      "Wordt gemarkeerd zodra je de eerste oefentoetsvraag opent."
  }
];
